import React, { useRef, useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import axios from "axios";
import { toast } from "react-toastify";
import { order_uri } from "../../../../utils/url";
import {Input, Spin} from "antd";
import TextArea from "antd/es/input/TextArea";

export default function TrackAddModal({callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
  const [data, setData] = useState({trackcode:"", phone_no:"", quantity:"1", payment:"", explanation:""});
  const barcodeInputRef = useRef(null);
  const phoneInputRef = useRef(null);
  const quantityRef = useRef(null);
  const paymentRef = useRef(null);
  const explanationRef = useRef(null);

  const [phone, setPhone] = useState(null);
  const [phonee, setPhonee] = useState(null);
  const [explanations, setExplanations] = useState([]);

  const call = () =>{
    callback();
  }

  const Sub = async()=>{
    if(data.trackcode === "" ||data.phone_no === "" ||data.quantity === "" ||data.payment === "" ||data.explanation === ""){
      return toast.warning("Мэдээлэл дутуу байна");
    }
    setLoad(true);
    try{
        const res = await axios.post(order_uri+'/register', data);
        if(res.status === 200){
            toast.success("Амжилттай");
            call();
            setData({...data, trackcode:"", phone_no:"", payment:"", explanation:""});
            setExplanations([]);
            setLoad(false);
            setTimeout(() => {
              barcodeInputRef.current.focus();
            }, 0);
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }
  
  const GetPhone = async()=>{
    if(data.trackcode === null){
      return
    }
    setLoad(true);
    try{
        const res = await axios.get(order_uri+'/phone/'+`${data.trackcode}`);
        setPhone(res.data.phone_no);
        setExplanations(res.data.explanations || []);
        // Эхний explanation-ийг автоматаар set хийх (хэрэв байвал)
        const firstExplanation = res.data.explanations && res.data.explanations.length > 0 
          ? res.data.explanations[0] 
          : "";
        setData({...data, phone_no: res.data.phone_no, explanation: firstExplanation});
        setLoad(false);
        setTimeout(() => {
          phoneInputRef.current.focus();
        }, 0);
        setPhonee("");
    }catch(err){
        console.log(err);
        setExplanations([]);
        setTimeout(() => {
          phoneInputRef.current.focus();
        }, 0);
        setPhonee("");
        setLoad(false);
    }
  }

  const GetExplanationsByPhone = async(phoneNumber = null)=>{
    const phone = phoneNumber || data.phone_no;
    if(!phone || phone.length !== 8){
      return
    }
    setLoad(true);
    try{
        const res = await axios.get(order_uri+'/phone-by-number/'+`${phone}`);
        setExplanations(res.data.explanations || []);
        // Эхний explanation-ийг автоматаар set хийх (хэрэв байвал)
        const firstExplanation = res.data.explanations && res.data.explanations.length > 0 
          ? res.data.explanations[0] 
          : data.explanation; // Хэрэв байхгүй бол одоогийн утгыг хадгална
        setData(prev => ({...prev, explanation: firstExplanation}));
        setLoad(false);
    }catch(err){
        console.log(err);
        setExplanations([]);
        setLoad(false);
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      GetPhone();
    }
  };


  const handleKeyDownQuantity = async (event) => {
    if (event.key === 'Enter') {
      if(data.phone_no && data.phone_no.length === 8){
        await GetExplanationsByPhone();
      }
      quantityRef.current.focus();
    }
  };
  const handleKeyDownPayment = (event) => {
    if (event.key === 'Enter') {
      paymentRef.current.focus();
    }
  };
  const handleKeyDownExplanation = (event) => {
    if (event.key === 'Enter') {
      explanationRef.current.focus();
    }
  };


  const onChangeTrack = (event) => {
    setData({...data, trackcode: event});
    // if(event.length > 13){
    //   setTimeout(() => {
    //     phoneInputRef.current.focus();
    //   }, 0);
    // }
  };

  const onChangePhone = async (event) => {
      setData({...data, phone_no: event});
      if(event.length !== 8){
        setPhonee("Утасны дугаар буруу байна.")
      }else{
        setPhonee("")
        // Утасны дугаар 8 оронтой болж дуусахад автоматаар explanation-уудыг авах
        await GetExplanationsByPhone(event);
      }
  };

  const handleKeySub = (event) => {
    if (event.key === 'Enter') {
      Sub();
    }
  };

  const handleModalClose = (isOpen) => {
    if (!isOpen) {
      // Modal хаагдах үед reset хийх
      setData({trackcode:"", phone_no:"", quantity:"1", payment:"", explanation:""});
      setPhone(null);
      setPhonee(null);
      setExplanations([]);
      setLoad(false);
    }
    onOpenChange(isOpen);
  };

  return (
    <>
      
      <Button size='sm' onClick={onOpen} className="ml-2">Ачаа бүртгэх</Button>
      <Modal placement="top" isOpen={isOpen} onOpenChange={handleModalClose} size="2xl">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 border-b">Ачаа бүртгэх</ModalHeader>
              <ModalBody>
                <div className="">
                  <div className="flex items-center gap-2 w-full">
                    <div className="w-full">
                      <h1>Бар код</h1>
                      <Input onKeyDown={handleKeyDown} ref={barcodeInputRef} autoFocus onChange={(e) => onChangeTrack(e.target.value)} value={data.trackcode} className="mt-1" placeholder="Бар код оруулах" size="sm"/>
                    </div>
                    <div className="w-full">
                      <h1>Утасны дугаар</h1>
                      <Input onKeyDown={handleKeyDownQuantity} onChange={(e) => onChangePhone(e.target.value)} ref={phoneInputRef} value={data.phone_no} className="mt-1" placeholder="Утасны дугаар оруулах" type="number" size="sm"/>
                      <p className="text-red-600 text-xs">{phonee}</p>
                      {/* <h1>{phone}</h1> */}
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full mt-2">
                    <div className="w-full">
                      <h1>Тоо хэмжээ</h1>
                      <Input onKeyDown={handleKeyDownPayment} ref={quantityRef} onChange={(e) => setData({...data, quantity:e.target.value})} value={data.quantity} className="mt-1" placeholder="0" size="sm" type="number"/>
                    </div>
                    <div className="w-full">
                      <h1>Карго үнэ</h1>
                      <Input onKeyDown={handleKeyDownExplanation} ref={paymentRef} onChange={(e) => setData({...data, payment:e.target.value})} value={data.payment} className="mt-1" placeholder="0" size="sm" type="number"/>
                    </div>
                  </div>
                  <div className="w-full mt-2">
                    <h1>Тайлбар</h1>
                    {explanations && explanations.length > 0 && (
                      <div className="mb-2 p-2 bg-gray-50 rounded border border-gray-200">
                        <p className="text-xs text-gray-600 mb-1">Сүүлийн тайлбарууд:</p>
                        <div className="flex gap-2">
                          {explanations.map((explanation, index) => (
                            <div 
                              key={index}
                              onClick={() => setData({...data, explanation: explanation})}
                              className={`text-xs px-4 py-2 rounded cursor-pointer hover:bg-blue-50 transition-colors ${
                                data.explanation === explanation ? 'bg-blue-100 border border-blue-300' : 'bg-white border border-gray-200'
                              }`}
                            >
                              {explanation}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <TextArea onKeyDown={handleKeySub} ref={explanationRef} onChange={(e) => setData({...data, explanation:e.target.value})} value={data.explanation} className="mt-1" placeholder="Тайлбар" size="sm" />
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onClick={() => {
                  setData({trackcode:"", phone_no:"", quantity:"1", payment:"", explanation:""});
                  setPhone(null);
                  setPhonee(null);
                  setExplanations([]);
                  setLoad(false);
                  onClose();
                }}>
                  Хаах
                </Button>
                {
                    load?
                    <Spin/>
                    :
                    <Button color="primary" onClick={Sub}>
                        Бүртгэх
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
